import SourceVideoThumbnail from 'SourceComponent/VideoThumbnail/VideoThumbnail.component';
import Image from 'Component/Image/Image.container';

export class VideoThumbnail extends SourceVideoThumbnail {
    render() {
        const {
            media: {
                base: { url },
                video_content: { video_title }
            },
            onPlayClick
        } = this.props;

        return (
            <div block="VideoThumbnail">
                <button
                  block="VideoThumbnail"
                  elem="Button"
                  onClick={ onPlayClick }
                  title={ __('Play video %s', video_title) }
                >
                    <Image
                      src={ url }
                      ratio="custom"
                      mix={ {
                          block: 'VideoThumbnail',
                          elem: 'Thumbnail',
                          mods: { isPlaceholder: !url }
                      } }
                      isPlaceholder={ !url }
                      alt={ video_title }
                    />
                    { this.renderPlayIcon() }
                </button>
            </div>
        );
    }
}

export default VideoThumbnail;
